import { useParams } from "react-router-dom";
import Section from "../components/Section.tsx";
import ProjectDescription from "../components/ProjectDescription.tsx";
import FourImagesInRow from "../components/FourImagesInRow.tsx";
import TwoImagesInRow from "../components/TwoImagesInRow.tsx";
import CardGrid from "../components/CardGrid.tsx";
import VideoSection from "../components/VideoSection.tsx";
import { commercialsData, petData } from "../navigationData.ts";
import { Typography } from "@mui/material";

const PortfolioItemPage = () => {
  const { id } = useParams();
  const anotherProjects = [...commercialsData, ...petData].filter(
    (data) => data.id !== Number(id)
  );
  const details = [...commercialsData, ...petData].find(
    (data) => data.id === Number(id)
  );

  if (!details) {
    return (
      <Section isLight={false}>
        <Typography
          variant="h3"
          sx={{ color: "black", textAlign: "center", my: 2 }}
        >
          oops, somerthing went wrong!!!
        </Typography>
      </Section>
    );
  }

  const renderScreenshorts = () => {
    if (details?.chipTitle.includes("Mobile")) {
      return (
        <Section isLight={false}>
          <FourImagesInRow details={details} />
        </Section>
      );
    } else
      return (
        <Section isLight={false}>
          <TwoImagesInRow details={details} />
        </Section>
      );
  };
  return (
    <>
      <Section isLight={true} paddingBottom={0}>
        <>
          <ProjectDescription details={details} />
        </>
      </Section>
      {renderScreenshorts()}
      {details.video && (
        <Section isLight={true}>
          <VideoSection details={details} />
        </Section>
      )}
      <Section title={"CHECK OTHER PROJECTS"} isLight={false}>
        <CardGrid list={anotherProjects} />
      </Section>
    </>
  );
};

export default PortfolioItemPage;
